(function(){
  function initRail(root){
    if(!root || root.dataset.inited) return;
    root.dataset.inited = '1';

    const ms    = Number(root.dataset.interval || 5000);
    const track = root.querySelector('.sp-vid-rail__track');
    const cards = [...root.querySelectorAll('.sp-vid-rail__card')];
    const n     = cards.length;
    if(!track || !n) return;

    const byIdx = i => cards[i];
    const vids  = cards.map(c => c.querySelector('video'));
    const covs  = cards.map(c => c.querySelector('.sp-vid-rail__cover'));
    vids.forEach(v => { if(v){ v.muted = true; v.setAttribute('playsinline',''); v.preload = 'metadata'; } });

    let i = 0;
    let timer;

    function orderAround(center){
      // nuevo método: usa order en lugar de mover nodos
      cards.forEach((card, idx)=>{
card.style.order = ((center - idx + n) % n);      });
    }

    function lockVideo(v, active){
      if(!v) return;
      try{
        v.pause();
        if(active){
          v.currentTime = 0;
          v.preload = 'auto';
          v.play().catch(()=>{});
        } else {
          v.preload = 'none';
        }
      }catch(e){}
    }

    function setActive(next){
      i = (next + n) % n;
      console.log('RAIL: cambiando a', i);

      orderAround(i);

      const childs = [...track.children];
      childs.forEach(c => {
        c.classList.remove('is-active');
        const cover = c.querySelector('.sp-vid-rail__cover');
        if(cover) cover.style.display = '';
        const v = c.querySelector('video');
        lockVideo(v, false);
      });

      const center = track.querySelector('.sp-vid-rail__card[style*="order:0"]') || track.children[2];
      const vAct   = center.querySelector('video');
      const cAct   = center.querySelector('.sp-vid-rail__cover');
      center.classList.add('is-active');
      if(cAct) cAct.style.display = 'none';
      lockVideo(vAct, true);
    }

    function start(){
      setActive(i);
      if (timer) clearInterval(timer);
      console.log('RAIL: timer iniciado cada', ms, 'ms');
      timer = setInterval(()=>{
        console.log('RAIL: tick');
        setActive(i + 1);
      }, ms);
    }

    function stop(){
      if(timer) clearInterval(timer);
    }

    track.addEventListener('click', (e)=>{
      const card = e.target.closest('.sp-vid-rail__card');
      if(!card) return;
      const orderValue = parseInt(card.style.order) || 0;
      const delta = -orderValue; // centro siempre order:0
      stop();
      setActive(i + delta);
      start();
    });

    const kick = ()=>{
      const v = track.querySelector('.sp-vid-rail__card[style*="order:0"] video');
      v && v.play().catch(()=>{});
      window.removeEventListener('click', kick);
      window.removeEventListener('scroll', kick);
    };
    window.addEventListener('click', kick, {once:true});
    window.addEventListener('scroll', kick, {once:true});

    document.addEventListener('visibilitychange', ()=>{
      if(document.hidden){ vids.forEach(v=>v && v.pause()); }
      else { setActive(i); }
    });

    start();
    console.log('RAIL: iniciado con', n, 'items');
    window.__rail_ok = true;
  }

  function initAll(){
    document.querySelectorAll('.sp-vid-rail').forEach(initRail);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', e=>{
    e.target && e.target.querySelectorAll && e.target.querySelectorAll('.sp-vid-rail').forEach(initRail);
  });
})();